import { nullToEmptyString } from "src/app/shared/helpers/shared-zero-to-null.function";
import { ExtRelSaveQueryI } from "./rel-save.query.ext";
import { RelSaveQueryI } from "./rel-save.query.int";
import { ExtRelSaveI } from "./rel-save.query.result.ext";
import { RelSaveResponseI } from "./rel-save.query.result.int";

export const MapRelSave = {
    // Map the incoming request to the internal query
    mapRequest: (int: RelSaveQueryI): ExtRelSaveQueryI => ({
        request: {
            piSeqnr: int.seqNr,
            pcNewLocation: nullToEmptyString(int.newLocation),
        }
    }),

    // Map the internal query result to the outgoing response
    mapResponse: (ext: ExtRelSaveI): RelSaveResponseI => ({
    }),
}